import { DEPENDENT_TABLES, ZALOHA_POV } from '@/modules/ojeteVozy/prodej/constants';
import { DropdownItem, DropdownList } from '@/main/store/@types/dropdown.d';
import { DepTables, EditStore, EditStoreProps } from '@/main/store/@types/edit.d';
import { DependetTableSetting } from '@/main/store/@types/store.d';

export class PovEdit {
	PovId: number | null = null;
	VstupDat: Date | null = null;
	ZakaznikId: number | null = null;
	ZakaznikIdText: string | null = null;
	Leaspodminky: string | null = null;
	LeassmlouNr: string | null = null;
	UzavreniDat: Date | null = null;
	VstupPracId: number | null = null;
	VstupPracIdText: string | null = null;
	EditDat: Date | null = null;
	EditPracId: number | null = null;
	EditPracIdText: string | null = null;
	UvolneniDat: Date | null = null;
	PovPzn: number | null = null;
	Oznam: string | null = null;
	Memo: string | null = null;
	PovNr: number | null = null;
	Pov2Pzn: number | null = null;
	LeaszakaznikId: number | null = null;
	LeaszakaznikIdText: number | null = null;
	ProvozovnaId: number | null = null;
	VstupProvId: number | null = null;
	VstupProvIdText: string | null = null;
	KomiseovNr: string | null = null;
	IntrDruhOzn: number | null = null;
	IntDruhDuvod: string | null = null;
	VyrazenPrp: boolean | null = null;
	ZalohaPredbez: number | null = null;
	PsmlouvaPfx: string | null = null;
	PsmlouvaNr: number | null = null;
	PsmlouvaDat: Date | null = null;
	RezervdoDat: Date | null = null;
	VyrobekvozOzn: string | null = null;
	VyrobekvozText: string | null = null;
	Typkod: string | null = null;
	TypkodText: string | null = null;
	BarvaKod: string | null = null;
	BarvaText: string | null = null;
	PoptText: string | null = null;
	StanovstPredani: string | null = null;
	MenaId1: number | null = null;
	MenaId2: number | null = null;
	KurzM2: number | null = null;
	Vozidlo: string | null = null;
	PovVariaList: number[] | null = null;
	VozidloText: string | null = null;
}

export class PovDropdownList implements DropdownList {
	ProvozovnaId = [];
	VyrobekvozOzn = [];
	PovPzn = [];
	Pov2Pzn = [];
	PovVaria = [];
	[key: string]: DropdownItem[]
}

interface PovProps extends EditStoreProps {
	filter?: object,
	id?: number,
}

export const props = {
	mode: null,
} as PovProps;

type State = EditStore<PovEdit, PovDropdownList, {}, DepTables<typeof DEPENDENT_TABLES>, typeof props>;

export const depTableSettings: Record<string, DependetTableSetting<State>> = {
	[ZALOHA_POV]: {
		loadByEntityId: true,
		filter(state) {
			return { PovId: state.props.id };
		},
	},
};
